"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textInputTypes = exports.mutableTags = exports.inputTags = void 0;
var inputTags = {
  INPUT: true,
  TEXTAREA: true,
  SELECT: true
};
exports.inputTags = inputTags;
var mutableTags = {
  INPUT: true,
  TEXTAREA: true,
  OPTION: true
};
exports.mutableTags = mutableTags;
var textInputTypes = {
  'datetime-local': true,
  'select-multiple': true,
  'select-one': true,
  color: true,
  date: true,
  datetime: true,
  email: true,
  month: true,
  number: true,
  password: true,
  range: true,
  search: true,
  tel: true,
  text: true,
  textarea: true,
  time: true,
  url: true,
  week: true
};
exports.textInputTypes = textInputTypes;